import MuiAppBar from "./MuiAppBar";
import MuiButton from "./MuiButton";
import MuiPaper from "./MuiPaper";
import MuiToolbar from "./MuiToolbar";

export default {
    MuiAppBar,
    MuiPaper,
    MuiToolbar,
    MuiButton
};